import * as React from "react";

import { Error404Message } from "spry-react/Errors/errorMessages";
import { ErrorPageBody } from "spry-react/Errors/errorPageBody";
import { colors } from "spry-react/utils/colors";
import { usePortalAppContext } from "../../Shared/appContext";
import { PortalFullPage } from "../../Shared/portalPage";

export function PortalPageNotFound() {
  const context = usePortalAppContext();
  return (
    <PortalFullPage
      title="Not Found"
      context={context}
      borderedHeader={true}
      headerContent={<h1>PAGE NOT FOUND (404)</h1>}
      children={
        <ErrorPageBody
          errorMessage={<Error404Message />}
          icon={{
            iconKey: "info",
            color: colors["attention"],
          }}
        />
      }
    />
  );
}
